import React, {Component} from 'react';
import Form from './containers/Form';
import 'bootstrap/dist/css/bootstrap.css';
import './css/main.css';
import helpers, {ADMIN_EMAIL} from "./containers/helpers";

class ErrorHandler extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            info: null
        }
    }

    componentDidCatch(error, info) {
        this.setState({error, info});
    }

    render() {
        if (this.state.error) {
            let subject = 'Order Doc Online: An error occurred';
            let body = '<pre>' + this.state.error + '<br>'+ this.state.info.componentStack +'</pre>';
            let formData = new FormData();
            formData.set('recipients', ADMIN_EMAIL);
            formData.set('subject', helpers.encrypt(subject));
            formData.set('message', helpers.encrypt(body));
            helpers.ajax('/mailer', formData).catch(err => console.error(err));
            return null;
        }
        return this.props.children;
    }
}

class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
            lang: props.lang
        };
    }

    componentWillMount() {
        let uri = window.top.location.href;
        let lang = uri.indexOf('lang=') === -1 ? 'ru' : uri.match(/lang=\w{2}/g)[0].split('=').pop();
        this.setState({lang: lang});
    }

    render() {
        if (this.state.hasError)
            return null;

        return (
            <ErrorHandler>
                <Form lang={this.state.lang} />
            </ErrorHandler>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js